export enum ShippingType {
  Pallets = 'pallets',
  Packages = 'packages'
}
